/**
 * CurrentTopics JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class CurrentTopics
 */
class CurrentTopics {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get the tab buttons
        this.tabControllers = $( '.js-current-topics-tabs-button' );

        // Get the read more buttons.
        this.readMoreBtns = $( '.js-current-topics-read-more-btn' );

        // Get the current topics tabs.
        this.currentTopicsTabs = $( '.js-current-topics-tab' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // A click event to control each tab-button
        this.tabControllers.each( ( e, current ) => {
            $( current ).on( 'click', ( e ) => {
                const tabToControl = $( e.currentTarget ).attr( 'data-controls' );
                const readMoreBtnToControlId = '#' + tabToControl + '-read-more';

                this.hideTabs( tabToControl, readMoreBtnToControlId );
            });
        });
    }

    /**
     * This controls the tabs and sets the current aria-expanded status to active button
     *
     * @param {string} activeTab
     * @param {string} activeBtn
     */
    hideTabs( activeTab, activeBtnId ) {

        // Hide all the other tabs except the selected one
        const activeTabId = '#' + activeTab;
        this.currentTopicsTabs.not( activeTabId ).addClass( 'js-hidden' );
        $( activeTabId ).removeClass( 'js-hidden' );

        // Hide all the read more buttons except the button of the selected tab.
        this.readMoreBtns.not( activeBtnId ).addClass( 'js-hidden' );
        $( activeBtnId ).removeClass( 'js-hidden' );

        // Control the buttons to work accordingly - aria-expanded -wise
        const activeTabButton = '.' + activeTab;
        const notActiveTab = this.tabControllers.not( activeTabButton );

        // Remove active indicators from not active tab button
        notActiveTab.attr( 'aria-expanded', 'false' );
        notActiveTab.removeClass( 'active-tab' );

        // Add active indicators to active tab button
        $( activeTabButton ).attr( 'aria-expanded', 'true' );
        $( activeTabButton ).addClass( 'active-tab' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();

        // Throw in the first active tab as parameter.
        this.hideTabs( 'to-date-tab-1', '#to-date-tab-1-read-more' );

        this.events();
    }
}

// Export the class reference.
module.exports = CurrentTopics;



// WEBPACK FOOTER //
// ./assets/scripts/current-topics.js